import { StepTag } from '../ts/types/case-status.types';

export const caseStatusSteps: StepTag[] = [
  {
    key: 'CREATED',
    text: 'synergy_case_status-created_text',
    title: 'synergy_case_status-created_title',
  },
  {
    key: 'ACCEPTED',
    text: 'synergy_case_status-accepted_text',
    title: 'synergy_case_status-accepted_title',
  },
  {
    key: 'STARTED',
    text: 'synergy_case_status-started_text',
    title: 'synergy_case_status-started_title',
  },
  {
    key: 'COMPLETED',
    text: 'synergy_case_status-completed_text',
    title: 'synergy_case_status-completed_title',
  },
  {
    key: 'CLOSED',
    text: 'synergy_case_status-closed_text',
    title: 'synergy_case_status-closed_title',
  },
];
